module.exports = __webpack_public_path__ + "img/bg-half-tri-blogdetails.1f0fb8d2.svg";